import React, { FC, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import "./FullScreenToast.css";
import { Icon } from "@material-ui/core";
import loadGif from "../../assets/lottie/success.gif";
import { useTranslation } from "i18n/useTranslation";

interface FullScreenToastProps {
  config: IFullScreenToastConfig | null;
}

export interface IFullScreenToastConfig {
  message?: string | JSX.Element;
  color?: string;
  type?: "error" | "success" | "warning";
  icon?: string;
  iconSize?: number;
  time?: number;
  onClickButton?: () => void;
  buttonText?: string;
  onClose?: () => void;
  background?: string;
}

export const FullscreenToast: FC<FullScreenToastProps> = ({ config }) => {
  const nodeRef = React.useRef<HTMLDivElement | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (config) {
      if (!!config?.time) {
        const time = setTimeout(() => {
          if (config?.onClose) {
            config.onClose();
          }
        }, config?.time ?? 6000);
        return () => {
          clearTimeout(time);
        };
      }
    }
  }, [config]);

  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      in={!!config}
      timeout={500}
      classNames="modal-sucess"
      nodeRef={nodeRef}
    >
      {
        <div className={"FullScreenToast"}>
          {config?.background && (
            <img
              id="fullscreen-toast-papelDeParedePlayer"
              src={config.background}
              alt="papel de Parede"
            ></img>
          )}
          <div className={"message-FullScreenToast"}>
            <div className={"icon-FullScreenToast"}>
              {config?.type === "success" ? (
                <img src={loadGif} alt="Loading" />
              ) : (
                <Icon
                  style={{
                    fontSize: config?.iconSize ?? 220,
                    color: config?.type === "error" ? "#F44336" : "yellow",
                  }}
                  fontSize="large"
                >
                  {config?.icon
                    ? config.icon
                    : config?.type === "error"
                    ? "cancel"
                    : config?.type === "warning"
                    ? "error"
                    : ""}
                </Icon>
              )}
            </div>
            <div className={"text-FullScreenToast"}>
              {config?.type === "success" ? t("order.toast.success_default") : ""}
              <span>{config?.message ?? ""}</span>
            </div>
            {(config?.onClickButton || config?.buttonText) && (
              <div
                className={"button-FullScreenToast"}
                onClick={() => {
                  config?.onClickButton?.();
                  config?.onClose?.();
                }}
              >
                {config.buttonText}
              </div>
            )}
          </div>
        </div>
      }
    </CSSTransition>
  );
};
